// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"7299f349","429":"ba67344e","923":"7ed535ef"}[chunkId] + ".chunk.js";
};